export default "__VITE_ASSET__fzwL7SvC__";